<div class="container-fluid">
    <!-- Page-Title -->
    <!-- end page title end breadcrumb -->
    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                        <!-- Add the following code inside your template -->
                       <!-- Add the following code inside your template -->
<div class="mb-3 d-flex flex-wrap align-items-center justify-content-between">
    <h4 class="mb-2 fw-bolder">Customer Master</h4>

    <div class="col-lg-12 d-flex flex-wrap align-items-center">
        <!-- Existing code ... -->

        <div class="col-lg-3 mb-2 mr-2">
            <label for="customerFilter" class="">Select Customer:</label>
            <div style="position: relative; display: inline-block;">
                <select id="customerFilter" class="form-control" [(ngModel)]="selectedCustomer"
                        style="padding-right: 25px; /* Adjust as needed */" (change)="onCustomerSelectionChange()">
                    <option value="">All Customers</option>
                    <option *ngFor="let customer of customerList" [value]="customer">{{ customer }}</option>
                </select>
                <div style="position: absolute; top: 50%; right: 5px; transform: translateY(-50%);">
                    &#9662; <!-- Down arrow character -->
                </div>
            </div>
        </div>

        <div class="col-lg-3 mb-2 mr-2">
            <label for="refNo" class="">Ref No:</label>
            <input type="text" id="refNo" class="form-control mb-2" [(ngModel)]="refNo" (input)="onRefNoChange()">
        </div>

        <div class="col-lg-2 mb-2 mr-2">
            <label for="fromDate" class="">From Date:</label>
            <input type="text" id="fromDate" placeholder="MM/DD/YYYY" class="form-control mb-2"
                [(ngModel)]="fromDate" (input)="onDateRangeChange()">
        </div>

        <div class="col-lg-2 mb-2 mr-2">
            <label for="toDate" class="">To Date:</label>
            <input type="text" id="toDate" placeholder="MM/DD/YYYY" class="form-control mb-2"
                [(ngModel)]="toDate" (input)="onDateRangeChange()">
        </div>

        <div class="col-lg-1 mb-2 pt-2">
            <button class="btn btn-outline-danger" (click)="onFilter()">Filter</button>
        </div>
    </div>
</div>

    
                    </div>

                <div class="table-responsive">
                    <table class="table mb-0 table-centered">
                        <thead>
                            <tr>
                                <th class="d-lg-table-cell" (click)="sortColumn('refNo')">Ref No<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('orderDate')">Order Date<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('ticketNo')">TicketNo<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('status')">Status<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('Customer_Name')">Customer Name<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('Job_Name')">Job Name<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('Job_Type')"> Job Type<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('Qty_Kgs')">Qty Kgs<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('Qty_Pcs')">Qty Pcs<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="d-lg-table-cell" (click)="sortColumn('Total_Disp')">Total Disp<span
                                        class="datatable-icon-sort-unset sort-btn"></span></th>
                                <th class="text-end d-lg-table-cell">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let user of displayedUsers">
                                <td class="d-lg-table-cell">{{user.refNo}}</td>
                                <td class="d-lg-table-cell">{{user.orderDate}}</td>
                                <td class="d-lg-table-cell">{{user.ticketNo}}</td>
                                <td class="d-lg-table-cell">{{user.status}}</td>
                                <td class="d-lg-table-cell">{{user.Customer_Name}}</td>
                                <td class="d-lg-table-cell">{{user.Job_Name}}</td>
                                <td class="d-lg-table-cell">{{user.Job_Type}}</td>
                                <td class="d-lg-table-cell">{{user.Qty_Kgs| number:'1.2-2':'en-US'}}</td>
                                <!-- <td class="d-lg-table-cell">{{user.Qty_Pcs}}</td> -->
                                <td  class="d-lg-table-cell">{{ getNumber(user.Qty_Pcs) | number:'1.0-0':'en-US' }}</td>

                                <td class="d-lg-table-cell">{{user.Total_Disp}}</td>
                                <td class="text-end d-lg-table-cell">
                                    <!-- Add action buttons here <td>{{ order.orderKgs | number:'1.2-2':'en-US' }}</td>
<td>{{ order.orderPcs | number:'1.0-0':'en-US' }}</td>
-->
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div class="datatable-footer-inner selected-count d-flex justify-content-between">
                    <div class="page-count mt-3 ng-star-inserted">
                        <span class="font-weight-bold">{{ displayedUsers.length }} of {{ totalItems }} total</span>
                    </div>
                    <div class="pagination mt-3 d-flex justify-content-center">
                        <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)"
                            [ngClass]="{'disabled': currentPage === 1}">
                            <i class="feather icon-chevrons-left"></i>
                        </a>
                        <a *ngFor="let page of getPages()" class="pagination-circle"
                            [class.active]="currentPage === page" (click)="onPageChange(page)">{{ page }}</a>
                        <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)"
                            [ngClass]="{'disabled': currentPage === mathLib.ceil(totalItems / itemsPerPage)}">
                            <i class="feather icon-chevrons-right "></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
